class WCProductBIS extends HTMLElement {
  constructor() {
    super();

    this.toggleButton = this.querySelector('[data-bis-toggle]')
    this.form = this.querySelector('[data-bis-form]')
    this.emailInput = this.querySelector('[data-bis-email-input]')
    this.errorMessage = this.querySelector('[data-bis-error-message]')
    this.stickyAtc = document.querySelector('[data-sticky-bar-atc-button]')
    this.productForm = document.querySelector(`[data-product-form="${this.dataset.sectionId}"]`)
  }

  connectedCallback() {
    if (!this.form || !this.toggleButton) {
      return null
    }

    this.form.addEventListener('submit', this.submitBis.bind(this))
    this.toggleButton.addEventListener('click', this.toggleForm.bind(this))
    this.stickyAtc?.addEventListener('click', this.toggleForm.bind(this))
    document.addEventListener('variant:change', this.toggleForm.bind(this))
  }

  disconnectedCallback() {
    this.form.removeEventListener('submit', this.submitBis.bind(this))
    this.toggleButton.removeEventListener('click', this.toggleForm.bind(this))
    this.stickyAtc?.removeEventListener('click', this.toggleForm.bind(this))
    document.removeEventListener('variant:change', this.toggleForm.bind(this))
  }

  toggleForm (event) {
    const productFormVariantEvent = event.type === 'variant:change'
    this.classList.toggle('open-form', !productFormVariantEvent)
    this.classList.remove('error', 'success')
    this.emailInput.value = ''
  }

  isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)

  submitBis = async (event) => {
    event.preventDefault()
    event.stopPropagation()

    this.classList.remove('error', 'success')

    try {
      const formData = new FormData(this.form)
      const inputEmail = formData.get('email')

      if (!this.isValidEmail(inputEmail)) {
        throw new Error('BIS: invalid email')
      }

      fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.dataset.publicKlaviyoId}`,
        {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: '2024-07-15',
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: inputEmail,
                    }
                  }
                },
                channels: ["EMAIL"],
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${this.productForm?.formActiveVartiant?.id}`
                  }
                }
              }
            }
          }),
        }
      ).then(result => {
        if (!result.ok) throw new Error('BIS: an error occurred', error)

        this.classList.add('success')
      })

    } catch (err) {
      console.error(err)
      this.classList.add('error')

      if(this.errorMessage !== null) {
        this.errorMessage.textContent = err.message
      }
    }
  }
}

if (typeof customElements.get('wc-product-bis') === 'undefined') {
  customElements.define('wc-product-bis', WCProductBIS);
}
